/** @jsxImportSource @emotion/react */
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import React, { useEffect } from "react";
import LandingPage from "./pages/LandingPage";
import LoginScreen from "./pages/Login";
import ResetPasswordScreen from "./pages/ResetPassword";
import CheckEmailScreen from "./pages/CheckEmail";
import VerificationScreen from "./pages/Verification";
import NewPasswordScreen from "./pages/NewPassword";
import ForgotPassword from "./pages/ForgotPassword";
import { useGetPageContainerSyles } from "./index.styles";
import DeviceContextProvider from "./context/DeviceContext";
import { CookiesProvider } from "react-cookie";
import Signup1 from "./pages/Signup1";
import ProfileCompletion from "./pages/ProfileCompletion";
import Instructions from "./pages/Instructions";
import "./App.css";
import { baseUrl } from "./connections";

import axios from "axios";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import DeleteAccount from "./pages/AccountDelete/index";
import Rewards from "./pages/Rewards";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/Campaigns/CampaignDetail";
import TicketHistory from "./pages/Campaigns/TicketHistory";
import Favourites from "./pages/Favourites";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import About from "./pages/About/about";
import Faq from "./pages/Home/FAQ/index";
import MoreBrands from "./pages/MoreBrands";
import MoreMails from "./pages/MoreMails";
import Notifications from "./pages/Notifications";
import PopupAdds from "./pages/PopupAdds/Addslist";
import AppFooter from "./components/AppFooter/index";
import { getMes } from "./firebase";
import { toast } from "react-toastify";
import { onMessageListener } from "./firebase";
import UserContextProvider from "./context/UserContext";
import CacheBuster from "./clearCache";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1 } },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <LoginScreen />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordScreen />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/check-email",
    element: <CheckEmailScreen />,
  },
  {
    path: "/verification",
    element: <VerificationScreen />,
  },
  {
    path: "/new-password",
    element: <NewPasswordScreen />,
  },
  {
    path: "/signup",
    element: <Signup1 />,
  },
  {
    path: "/complete-profile",
    element: <ProfileCompletion />,
  },
  {
    path: "/signup-aws",
    element: <Navigate replace to="/signup" />,
  },
  {
    path: "/signup1",
    element: <Navigate replace to="/signup" />,
  },
  {
    path: "/singnup",
    element: <Navigate replace to="/signup" />,
  },
  {
    path: "/instructions",
    element: <Instructions />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/favourites",
    element: <Favourites />,
  },
  {
    path: "/rewards",
    element: <Rewards />,
  },
  {
    path: "/campaigns",
    element: <Campaigns />,
  },
  {
    path: "/campaigns/:campaignUuid",
    element: <CampaignDetail />,
  },
  {
    path: "/my-bookings",
    element: <TicketHistory />,
  },
  {
    path: "/ticket-history",
    element: <Navigate to="/my-bookings" replace />,
  },
  {
    path: "/Notifications",
    element: <Notifications />,
  },
  {
    path: "/PopUp-Adds",
    element: <PopupAdds />,
  },
  {
    path: "/my-account",
    element: <Profile />,
  },
  {
    path: "/delete-account",
    element: <DeleteAccount />,
  },
  {
    path: "/support",
    element: <AppFooter />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/moreBrands",
    element: <MoreBrands />,
  },
  {
    path: "/moreMails",
    element: <MoreMails />,
  },
]);

function App() {
  const checkSafari = () => {
    return (
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window[`${"safari"}`] ||
          (typeof safari !== "undefined" &&
            window[`${"safari"}`].pushNotification),
      )
    );
  };

  useEffect(() => {
    if (!checkSafari()) getMes();
  }, []);

  useEffect(() => {
    if (!checkSafari()) {
      onMessageListener()
        .then((message) => {
          toast.success(message?.notification?.title);
        })
        .catch((err) => {
          toast.error(JSON.stringify(err));
        });
    }
  }, []);

  let userdata = null;
  try {
    const raw = localStorage.getItem("user");
    if (raw && raw !== "undefined") {
      userdata = JSON.parse(raw);
    }
  } catch (e) {
    console.warn("Failed to parse user from localStorage", e);
  }

  // Restore dInfo cookies from localStorage on every app load
  // so Bingo can pick up identity even after browser restart
  useEffect(() => {
    if (!userdata) return;
    const fields = [
      ["dInfoUserEmail", userdata?.dInfoUserEmail],
      ["dInfoUserId", userdata?.dInfoUserId],
      ["dInfoUserType", userdata?.dInfoUserType],
      ["dInfoToken", userdata?.token],
    ];
    fields.forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        const maxAge = 30 * 24 * 60 * 60;
        const host = window.location.hostname;
        const domainAttr =
          host === "localhost"
            ? ";domain=localhost"
            : host.endsWith("money-mails.com")
              ? ";domain=.money-mails.com"
              : "";
        document.cookie = `${key}=${encodeURIComponent(value)};path=/;max-age=${maxAge}${domainAttr}`;
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // const { noticationdata, count,setPayloadsdata , setpage, } = Notificationconsumer();

  // const { noticationdata, setPayloadsdata } = Notificationconsumer();

  // useEffect(() => {
  //   // setPayloadsdata( currentUser?.data?.uuid);
  //   const interval = setInterval(() => (Notificationlist()), 10 * 60 * 1000)
  //   return () => {
  //     clearInterval(interval);
  //   }
  // }, [])

  const Notificationlist = () => {
    axios
      .get(
        `${baseUrl}/notification/list/consumer?page=&limit=10&user_uuid=${userdata?.uuid}`,
        {
          headers: {
            "x-auth-token": userdata?.token,
          },
        },
      )
      .then((res) => {
        // UserPayload(true)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const classes = useGetPageContainerSyles();

  <CacheBuster>
    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (loading) return null;
      if (!loading && !isLatestVersion) {
        // refreshCacheAndReload();
      }
      return (
        <div className="App">
          <header className="App-header">
            <h1>Cache Busting - Example</h1>
            <p>
              Bundle version - <code>v{global.appVersion}</code>
            </p>
          </header>
        </div>
      );
    }}
  </CacheBuster>;

  return (
    <QueryClientProvider client={queryClient}>
      <div css={classes.pageContainer}>
        <CookiesProvider>
          <DeviceContextProvider>
            <UserContextProvider>
              <RouterProvider router={router} />
            </UserContextProvider>
          </DeviceContextProvider>
        </CookiesProvider>
      </div>
    </QueryClientProvider>
  );
}

export default App;
